import { FC, useState } from "react";
import { LineChartElem } from "componentsNew/charts/LineChartTemp";
import { BarChartElem } from "componentsNew/charts/BarChartTemp";
import { TabSwitch } from "componentsNew/elements/TabSwitch";
import { Box } from "@material-ui/core";

interface DashboardGraphProps {
  data: any;
  margin: any;
  height: number;
  hideLegend?: boolean;
}

export const RolesTimeRangeGraph: FC<DashboardGraphProps> = ({
  data,
  margin,
  height,
  hideLegend,
}) => {
  return (
    <LineChartElem
      dataset={data || []}
      xAxis={[{ dataKey: "label", scaleType: "point" }]}
      series={[
        { dataKey: "standard_large", label: "Standard Large", color: "#0129FA" },
        { dataKey: "standard_cube", label: "Standard Cube", color: "#011DA7" },
        { dataKey: "standard_other", label: "Standard Other", color: "#627282" },
        { dataKey: "flex", label: "Flex", color: "#7A90FF" },
        { dataKey: "cancelled", label: "Cancelled", color: "#C42020" },
        { dataKey: "rejected", label: "Rejected", color: "#C28400" },
        { dataKey: "other", label: "Other", color: "#164578" },
      ]}
      margin={margin}
      height={height}
      slotProps={{
        legend: {
          hidden: hideLegend,
          itemMarkWidth: 24,
          itemMarkHeight: 4,
        },
        popper: {
          placement: "top",
        },
      }}
      sx={{
        ".MuiLineElement-series-auto-generated-id-5, .MuiLineElement-series-auto-generated-id-6, .MuiLineElement-series-auto-generated-id-7, .MuiLineElement-series-auto-generated-id-8, .MuiLineElement-series-auto-generated-id-9":
          { strokeDasharray: "6, 4" },
      }}
    />
  );
};

export const RoleTotalsGraph: FC<DashboardGraphProps> = ({ data, margin, height }) => {
  const [activeTab, setActiveTab] = useState<string>("da-shifts");
  const tabList = [
    { id: "da-shifts", name: "DA Shifts" },
    { id: "operation-shifts", name: "Operation Shifts" },
  ];

  return (
    <>
      <Box style={{ margin: "0 24px" }}>
        <TabSwitch activeTab={activeTab} tabList={tabList} action={setActiveTab} />
      </Box>
      <BarChartElem
        dataset={
          data?.filter((item: any) =>
            activeTab === "da-shifts"
              ? ![
                  "Dispatcher",
                  "Support Dispatcher",
                  "Supervisor",
                  "Fleet Coordinator",
                  "Perfomance Coordinator",
                ].includes(item.name)
              : [
                  "Dispatcher",
                  "Support Dispatcher",
                  "Supervisor",
                  "Fleet Coordinator",
                  "Perfomance Coordinator",
                ].includes(item.name),
          ) || []
        }
        xAxis={[
          { position: undefined, tickMinStep: 1, valueFormatter: (value: any) => value.toFixed(0) },
        ]}
        yAxis={[{ scaleType: "band", dataKey: "name" }]}
        series={[
          {
            type: "bar",
            dataKey: "count",
            label: "",
            valueFormatter: (value: number | null) => value,
            color: "#0129FA",
          },
        ]}
        margin={margin}
        height={height}
        layout={"horizontal"}
      />
    </>
  );
};

export const DeliveryTimeRangeGraph: FC<DashboardGraphProps> = ({
  data,
  margin,
  height,
  hideLegend,
}) => {
  return (
    <LineChartElem
      dataset={data || []}
      xAxis={[{ dataKey: "label", scaleType: "point" }]}
      series={[{ dataKey: "deliveries", label: "Deliveries", color: "#0129FA" }]}
      margin={margin}
      height={height}
      slotProps={{
        legend: {
          hidden: hideLegend,
        },
        popper: {
          placement: "top",
        },
      } as any}
    />
  );
};

export const ReturnsTrendsGraph: FC<DashboardGraphProps> = ({
  data,
  margin,
  height,
  hideLegend,
}) => {
  return (
    <LineChartElem
      dataset={data || []}
      xAxis={[{ dataKey: "label", scaleType: "point" }]}
      series={[
        { dataKey: "uta", label: "UTA", color: "#0129FA", showMark: false },
        { dataKey: "utl", label: "UTL", color: "#C28400", showMark: false },
        { dataKey: "nsl", label: "NSL", color: "#C42020", showMark: false },
        { dataKey: "bc", label: "BC", color: "#164578", showMark: false },
        { dataKey: "otp_failure", label: "OTP Failure", color: "#1B7E43", showMark: false },
        { dataKey: "missing", label: "Missing", color: "#011DA7", showMark: false },
        { dataKey: "missort", label: "Missort", color: "#7A5200", showMark: false },
        { dataKey: "damage", label: "Damage", color: "#881414", showMark: false },
        { dataKey: "fdd", label: "FDD", color: "#881414", showMark: false },
        { dataKey: "oc", label: "OC", color: "#145E32", showMark: false },
        { dataKey: "others", label: "Others", color: "#7A90FF", showMark: false },
      ]}
      margin={margin}
      height={height}
      slotProps={{
        legend: {
          hidden: hideLegend,
          direction: "column",
          position: { vertical: "middle", horizontal: "right" },
          itemMarkWidth: 24,
          itemMarkHeight: 4,
        },
        popper: {
          placement: "top",
        },
      }}
      sx={{
        ".MuiLineElement-series-auto-generated-id-5, .MuiLineElement-series-auto-generated-id-6, .MuiLineElement-series-auto-generated-id-7, .MuiLineElement-series-auto-generated-id-8, .MuiLineElement-series-auto-generated-id-9":
          { strokeDasharray: "6, 4" },
      }}
    />
  );
};

export const ReturnsTotalsGraph: FC<DashboardGraphProps> = ({ data, margin, height }) => {
  return (
    <BarChartElem
      dataset={data}
      xAxis={[
        { position: undefined, tickMinStep: 1, valueFormatter: (value: any) => value.toFixed(0) },
      ]}
      yAxis={[{ scaleType: "band", dataKey: "name" }]}
      series={[
        {
          type: "bar",
          dataKey: "count",
          label: "",
          valueFormatter: (value: number | null) => value,
          color: "#0129FA",
        },
      ]}
      margin={margin}
      height={height}
      layout={"horizontal"}
    />
  );
};

export const ActiveDATimeRangeGraph: FC<DashboardGraphProps> = ({
  data,
  margin,
  height,
  hideLegend,
}) => {
  return (
    <LineChartElem
      dataset={data || []}
      xAxis={[{ dataKey: "label", scaleType: "point" }]}
      series={[
        { dataKey: "max_shift_count", label: "Shift Count", color: "#0129FA", showMark: false },
        { dataKey: "max_active_count", label: "Active Count", color: "#C28400", showMark: false },
        {
          dataKey: "max_inactive_count",
          label: "Inactive Count",
          color: "#C42020",
          showMark: false,
        },
        {
          dataKey: "max_offboarded_count",
          label: "Offboarded Count",
          color: "#164578",
          showMark: false,
        },
      ]}
      margin={margin}
      height={height}
      slotProps={{
        legend: {
          hidden: hideLegend,
        },
        popper: {
          placement: "top",
        },
      }}
    />
  );
};

export const ActiveFleetsTimeRangeGraph: FC<DashboardGraphProps> = ({
  data,
  margin,
  height,
  hideLegend,
}) => {
  return (
    <LineChartElem
      dataset={data || []}
      xAxis={[{ dataKey: "label", scaleType: "point" }]}
      series={[
        { dataKey: "max_fleet_count", label: "Fleet Count", color: "#0129FA", showMark: false },
        { dataKey: "max_active_count", label: "Active Count", color: "#C28400", showMark: false },
        {
          dataKey: "max_inactive_count",
          label: "Inactive Count",
          color: "#C42020",
          showMark: false,
        },
        {
          dataKey: "max_offboarded_count",
          label: "Offboarded Count",
          color: "#164578",
          showMark: false,
        },
      ]}
      margin={margin}
      height={height}
      slotProps={{
        legend: {
          hidden: hideLegend,
        },
        popper: {
          placement: "top",
        },
      }}
    />
  );
};

export const RejectedGraph: FC<DashboardGraphProps> = ({ data, margin, height }) => {
  const paddedDataset = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((dayName) => {
    const existingDay = data.find((d: any) => d.weekday_name === dayName);
    return {
      weekday_name: dayName,
      count: existingDay ? existingDay.count : 0,
    };
  });
  return (
    <BarChartElem
      dataset={paddedDataset}
      xAxis={[
        {
          scaleType: "band",
          dataKey: "weekday_name",
          data: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        },
      ]}
      yAxis={[]}
      series={[
        {
          type: "bar",
          dataKey: "count",
          label: "",
          valueFormatter: (value: number | null) => `${value ?? 0}`,
          color: "#0129FA",
        },
      ]}
      margin={margin}
      height={height}
      layout={"vertical"}
    />
  );
};
